import React, { useState, useEffect } from 'react';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import axios from '../../api/axios';
import makeAnimated from "react-select/animated";
import { format } from 'date-fns';
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Button, Col, Form, FormCheck, FormControl, FormLabel, FormSelect, Modal, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

const EditModal = ({ isVisible, selectedUsers, setOpenEditModal, setFile, setSelectedUsers, setCouponData, setFromDate, setToDate, setSelectedCategories, setSelectedProducts, userCouponId, fetchData, selectedCategories, selectedProducts, addonList, getProductsList, usersInfo, handleSelectUsersChange, debouncedGetUsersList, categoriesData, handleSelectCategoryChange, productsInfo, handleSelectProductChange, editOutletData, levelsData, outletData, updatingData, setUserCouponId, exProductList, newSizeAddonsList, allAddonList }) => {

    const animatedComponents = makeAnimated();
    const accessToken = localStorage.getItem("authToken");
    const [editCouponData, setEditCouponData] = useState({
        isBogoCoupon: false,
        status: "",
        isSizeUpgradeCoupon: false,
        newSizeUpgradeAddon:"",
        sizeUpgradeAddon: "",
        title: "",
        description: "",
        usageType: "",
        couponCode: "",
        discountPercent: "",
        dayOfWeek: "",
        discountAmount: "",
        validityStartDate: "",
        validityEndDate: "",
        startTime: "",
        endTime: "",
        discountPrice: "",
        orderType: "ALL",
        applicableQuantityType: "",
        termsAndConditions: [], // Array to store terms
        isComboCategoryCoupon: false,
        maxAddonsAllowed: null,
        maxDiscountAmount: "",
        minOrderAmount: "",
        isMrpDiscount: false,
        excludedAddons: [] // Add excludedAddons array
    });
    const [currentTerm, setCurrentTerm] = useState('');
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [editSelections, setEditSelections] = useState({
        selectedIncludedOutlets: [],
        selectedExcludedOutlets: [],
        selectedApplicableLevels: [],
        primaryComboCategories: [],
        secondaryComboCategories: [],
        selectedDependentCategories: [],
        selectedDependentProducts: [],
        selectedExcludedProducts: [],
        selectedApplicableProducts: [],
        selectedApplicableCategories: []
    });
    
    // Add these states for addon management
    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
    const [selectedAddonValues, setSelectedAddonValues] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: '6px',
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d"
        }),
    };

    // Add this function to handle addon group selection in edit modal
    const handleEditSelectAllAddonChange = (type, selectedOptions) => {
        if (type === 'excludedAddonGroups') {
            setSelectedAddonGroups(selectedOptions || []);
            
            // When addon groups are selected, update the filtered addon values
            if (selectedOptions && selectedOptions.length > 0) {
                const selectedGroupIds = selectedOptions.map(option => option.value);
                const valuesFromSelectedGroups = allAddonList
                    .filter(addon => selectedGroupIds.includes(addon._id))
                    .flatMap(addon => 
                        addon.addonValues.map(value => ({
                            value: {
                                addonId: addon._id,
                                addValueId: value._id,
                                addonTitle: addon.title,
                                addonValueTitle: value.value
                            },
                            label: `${addon.title} - ${value.value}`
                        }))
                    );
                setFilteredAddonValues(valuesFromSelectedGroups);
            } else {
                setFilteredAddonValues([]);
                setSelectedAddonValues([]);
            }
        }
    };

    // Add this function to handle addon value selection in edit modal
    const handleEditAddonValueChange = (selectedOptions) => {
        setSelectedAddonValues(selectedOptions || []);
        
        // Update editCouponData with the excludedAddons array
        // const excludedAddons = selectedOptions ? selectedOptions.map(option => option.value) : [];

        // Update editCouponData with the excludedAddons array using addonValueId
        const excludedAddons = selectedOptions ? selectedOptions.map(option => ({
            addonId: option.value.addonId,
            addonValueId: option.value.addValueId, // This will be sent as addonValueId in payload
            addonTitle: option.value.addonTitle,
            addonValueTitle: option.value.addonValueTitle
        })) : [];

        setEditCouponData(prev => ({
            ...prev,
            excludedAddons: excludedAddons
        }));
    };

    // Filters `addonList` by matching the product `_id` with the first value in `selectedProducts` if it's an array, or directly if it's a single value, otherwise returns an empty array.
    const editFilteredAddon = editSelections?.selectedApplicableProducts?.length
        ? addonList.filter((item) =>
            editSelections.selectedApplicableProducts.some(
                (selected) => item.product?._id === selected.value
            )
        )
        : [];

    const exProductsInfo = exProductList.map((pro) => ({
        value: pro?._id,
        label: `${pro?.name}`
    }));

    const assignExistingData = (data) => {
        setUserCouponId(data?._id);

        let selectedEditedUsers = data?.users || [];
        let mappedSelectedEditedUsers = selectedEditedUsers.map((m) => ({
            value: m?._id,
            label: m?.name
        }));
        setSelectedUsers(mappedSelectedEditedUsers);

        const formattedStartDate = data?.coupon_id?.validityStartDate ? format(data?.coupon_id?.validityStartDate, "yyyy-MM-dd") : null;

        const formattedEndDate = data?.coupon_id?.validityEndDate ? new Date(data?.coupon_id?.validityEndDate).toISOString().split("T")[0] : null;

        let selectedEditedApplicableCategories = data?.coupon_id?.applicableCategories ? data?.coupon_id?.applicableCategories : [];

        let mappedSelectedEditedApplicableCategories = selectedEditedApplicableCategories.map((m) => ({
            value: m?._id,
            label: m?.name
        }));

        let selectedEditedApplicableProducts = data?.coupon_id?.applicableProducts ? data?.coupon_id?.applicableProducts : [];

        let mappedSelectedEditedApplicableProducts = selectedEditedApplicableProducts.map((m) => ({
            value: m?._id,
            label: m?.name
        }));

        const formattedSelections = {};

        if (data?.coupon_id?.primaryComboCategories?.length || data?.coupon_id?.secondaryComboCategories?.length) {
            formattedSelections.primaryComboCategories = data?.coupon_id?.primaryComboCategories?.map((inc) => ({
                value: inc?._id,
                label: inc?.name,
            }));

            formattedSelections.secondaryComboCategories = data?.coupon_id?.secondaryComboCategories?.map((inc) => ({
                value: inc?._id,
                label: inc?.name,
            }));
        }

        if (data?.coupon_id?.includedOutlets?.length) {
            formattedSelections.selectedIncludedOutlets = data?.coupon_id?.includedOutlets?.map((inc) => ({
                value: inc?._id,
                label: inc?.name,
            }));
        }

        if (data?.coupon_id?.applicableCategories?.length) {
            formattedSelections.selectedApplicableCategories = data?.coupon_id?.applicableCategories?.map((inc) => ({
                value: inc?._id,
                label: inc?.name,
            }));
        }

        if (data?.coupon_id?.excludedOutlets?.length) {
            formattedSelections.selectedExcludedOutlets = data?.coupon_id?.excludedOutlets?.map((exc) => ({
                value: exc?._id,
                label: exc?.name,
            }));
        }

        if (data?.coupon_id?.applicableLevels?.length) {
            formattedSelections.selectedApplicableLevels = data?.coupon_id?.applicableLevels?.map((lvl) => ({
                value: lvl?._id,
                label: lvl?.title,
            }));
        }

        if (data?.coupon_id?.applicableProducts?.length) {
            formattedSelections.selectedApplicableProducts = data?.coupon_id?.applicableProducts?.map((lvl) => ({
                value: lvl?._id,
                label: lvl?.name,
            }));
        }
        if (data?.coupon_id?.dependantCategories?.length) {
            formattedSelections.selectedDependentCategories = data?.coupon_id?.dependantCategories?.map((lvl) => ({
                value: lvl?._id,
                label: lvl?.name,
            }));
        }
        if (data?.coupon_id?.dependantProducts?.length) {
            formattedSelections.selectedDependentProducts = data?.coupon_id?.dependantProducts?.map((lvl) => ({
                value: lvl?._id,
                label: lvl?.name,
            }));
        }
        if (data?.coupon_id?.excludedProducts?.length) {
            formattedSelections.selectedExcludedProducts = data?.coupon_id?.excludedProducts?.map((lvl) => ({
                value: lvl?._id,
                label: lvl?.name,
            }));
        }

        setEditSelections(formattedSelections);

        // Handle excludedAddons data
        const excludedAddons = data?.coupon_id?.excludedAddons || [];
        
        // Set selected addon groups based on excludedAddons
        const addonGroupIds = [...new Set(excludedAddons.map(item => item.addonId))];
        const selectedGroups = allAddonList
            .filter(addon => addonGroupIds.includes(addon._id))
            .map(addon => ({
                value: addon._id,
                label: addon.title
            }));
        setSelectedAddonGroups(selectedGroups);

        // Set filtered addon values based on selected groups
        if (selectedGroups.length > 0) {
            const valuesFromSelectedGroups = allAddonList
                .filter(addon => addonGroupIds.includes(addon._id))
                .flatMap(addon => 
                    addon.addonValues.map(value => ({
                        value: {
                            addonId: addon._id,
                            addValueId: value._id,
                            addonTitle: addon.title,
                            addonValueTitle: value.value
                        },
                        label: `${addon.title} - ${value.value}`
                    }))
                );
            setFilteredAddonValues(valuesFromSelectedGroups);
        }

        // Set selected addon values
        const selectedValues = excludedAddons.map(item => ({
            value: {
                addonId: item.addonId,
                addValueId: item.addonValueId,
                addonTitle: item.addonTitle,
                addonValueTitle: item.addonValueTitle
            },
            label: `${item.addonTitle} - ${item.addonValueTitle}`
        }));
        setSelectedAddonValues(selectedValues);

        setEditCouponData({
            _id: data?.coupon_id?._id,
            title: data?.coupon_id?.title,
            isHidden: data?.coupon_id?.isHidden,
            couponCode: data?.coupon_id?.couponCode,
            description: data?.coupon_id?.description,
            validityStartDate: formattedStartDate,
            dayOfWeek: data?.coupon_id?.dayOfWeek,
            validityEndDate: formattedEndDate,
            startTime: data?.coupon_id?.startTime,
            endTime: data?.coupon_id?.endTime,
            termsAndConditions: data?.coupon_id?.termsAndConditions,
            isComboCategoryCoupon: data?.coupon_id?.isComboCategoryCoupon,
            isMrpDiscount: data?.coupon_id?.isMrpDiscount,
            usageType: data?.coupon_id?.usageType,
            orderType: data?.coupon_id?.orderType,
            status: data?.coupon_id?.status,
            excludedAddons: excludedAddons, // Set excludedAddons from existing data
            ...(data?.coupon_id?.discountAmount !== null && { discountAmount: data?.coupon_id?.discountAmount }),
            ...(data?.coupon_id?.discountPercent !== null && { discountPercent: data?.coupon_id?.discountPercent }),
            ...(data?.coupon_id?.maxDiscountAmount !== null && { maxDiscountAmount: data?.coupon_id?.maxDiscountAmount }),
            ...(data?.coupon_id?.discountPrice !== null && { discountPrice: data?.coupon_id?.discountPrice }),
            ...(data?.coupon_id?.minOrderAmount !== null && { minOrderAmount: data?.coupon_id?.minOrderAmount }),
            ...(data?.coupon_id?.maxAddonsAllowed !== null && { maxAddonsAllowed: data?.coupon_id?.maxAddonsAllowed }),
            ...(data?.coupon_id?.applicableQuantityType !== null && { applicableQuantityType: data?.coupon_id?.applicableQuantityType }),
            ...(data?.coupon_id?.isBogoCoupon === true && { isBogoCoupon: data?.coupon_id?.isBogoCoupon }),
            ...(data?.coupon_id?.newSizeUpgradeAddon !== null && { newSizeUpgradeAddon: data?.coupon_id?.newSizeUpgradeAddon, isSizeUpgradeCoupon: true })
        });
        setSelectedCategories(mappedSelectedEditedApplicableCategories);
        setSelectedProducts(mappedSelectedEditedApplicableProducts);
    }

    const handleChange = (key, value) => {
        setEditSelections((prev) => ({
            ...prev,
            [key]: value,
        }));

        if (key === "selectedApplicableCategories") {
            getProductsList(value);
        }
    };

    const addEditTerm = () => {
        if (!currentTerm.trim()) return;
        setEditCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: Array.isArray(prevData.termsAndConditions)
                ? [...prevData.termsAndConditions, currentTerm]
                : [currentTerm], // Fallback to an array if it's not already one
        }));
        setCurrentTerm(''); // Clear input after adding
    };

    const removeEditTerm = (index) => {
        setEditCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: Array.isArray(prevData.termsAndConditions)
                ? prevData.termsAndConditions.filter((_, i) => i !== index)
                : [], // Ensure it doesn't break if termsAndConditions is undefined
        }));
    };

    const handleEditValidStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(new Date(date), "yyyy-MM-dd");
            setEditCouponData((prev) => ({
                ...prev,
                validityStartDate: formattedDate,
            }));
        } else {
            setEditCouponData((prev) => ({
                ...prev,
                validityStartDate: null,
            }));
        }
    };

    const handleEditValidEndDateChange = (date) => {
        if (date) {
            const formattedDate = format(new Date(date), "yyyy-MM-dd");
            setEditCouponData((prev) => ({
                ...prev,
                validityEndDate: formattedDate,
            }));
        } else {
            setEditCouponData((prev) => ({
                ...prev,
                validityEndDate: null,
            }));
        }
    };

    // Handles input changes for the edit form. Updates the state for `editCouponData` and `selectedProducts`
    const handleEditInputChange = (e) => {
        const { name, value } = e.target;

        // Update the editCouponData state
        setEditCouponData((prev) => ({
            ...prev,
            [name]: name === "applicableProducts" ? [value] : value,
        }));

        // Update the selectedProducts state
        if (name === "applicableProducts") {
            setSelectedProducts([{ value }]); // Ensuring it's an array with the selected value
        }
    };

    const submitEditForm = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            // const selectedCategoriesData = selectedCategories.map((c) => c.value);
            const selectedProductsData = selectedProducts.map((c) => c.value);

            const selectedIncludedOutlets = editSelections?.selectedIncludedOutlets?.map((option) => option.value) || [];
            const selectedExcludedOutlets = editSelections?.selectedExcludedOutlets?.map((option) => option.value) || [];
            const selectedApplicableLevels = editSelections?.selectedApplicableLevels?.map((option) => option.value) || [];
            const selectedPrimaryComboCategories = editSelections?.primaryComboCategories?.map((option) => option.value) || [];
            const selectedSecondaryComboCategories = editSelections?.secondaryComboCategories?.map((option) => option.value) || [];

            const selectedDependentCategories = editSelections?.selectedDependentCategories?.map((option) => option.value) || []

            const selectedDependentProducts = editSelections?.selectedDependentProducts?.map((option) => option.value) || []

            const selectedExcludedProducts = editSelections?.selectedExcludedProducts?.map((option) => option.value) || [];

            const selectedApplicableProducts = editSelections?.selectedApplicableProducts?.map((option) => option.value) || []

            const selectedApplicableCategories = editSelections?.selectedApplicableCategories?.map((option) => option.value) || []

            // Initialize updatedCouponData immediately
            const updatedCouponData = {
                ...editCouponData,
                applicableCategories: selectedApplicableCategories.length > 0 ? selectedApplicableCategories : null,
                primaryComboCategories: selectedPrimaryComboCategories.length > 0 ? selectedPrimaryComboCategories : null,
                secondaryComboCategories: selectedSecondaryComboCategories.length > 0 ? selectedSecondaryComboCategories : null,
                applicableLevels: selectedApplicableLevels.length > 0 ? selectedApplicableLevels : null,
                includedOutlets: selectedIncludedOutlets.length > 0 ? selectedIncludedOutlets : null,
                excludedOutlets: selectedExcludedOutlets.length > 0 ? selectedExcludedOutlets : null,
                dependantCategories: selectedDependentCategories.length > 0 ? selectedDependentCategories : null,
                dependantProducts: selectedDependentProducts.length > 0 ? selectedDependentProducts : null,
                excludedProductList: selectedExcludedProducts.length > 0 ? selectedExcludedProducts : null,
                applicableProducts: selectedApplicableProducts.length > 0 ? selectedApplicableProducts : null,
                // excludedAddons is already included from editCouponData
            };

            if (!updatedCouponData.excludedOutlets || updatedCouponData.excludedOutlets.length === 0) {
                updatedCouponData.excludedOutlets = null;
            }

            // Clean up empty excludedAddons array
            if (Array.isArray(updatedCouponData.excludedAddons) && updatedCouponData.excludedAddons.length === 0) {
                updatedCouponData.excludedAddons = null;
            }

            // Discount amount and percent conflict handling
            if (updatedCouponData?.discountAmount) delete updatedCouponData?.discountPercent;
            if (updatedCouponData?.discountPercent) delete updatedCouponData?.discountAmount;

            if (updatedCouponData.maxAddonsAllowed === "" || updatedCouponData.maxAddonsAllowed === undefined || updatedCouponData.maxAddonsAllowed === null) {
                updatedCouponData.maxAddonsAllowed = null
            }

            Object.keys(updatedCouponData).forEach((key) => {
                // If 'dayOfWeek' is "all", set it to null
                if (key === 'dayOfWeek' && updatedCouponData[key] === "all") {
                    updatedCouponData[key] = null;
                }

                // Convert empty values to null
                if (updatedCouponData[key] === "" || updatedCouponData[key] === undefined || updatedCouponData[key] === null) {
                    updatedCouponData[key] = null;
                }
            });

            console.log("updatedCouponData", updatedCouponData);

            const response = await axios.put("coupons", updatedCouponData, { headers });

            if (response?.status === 200) {
                const couponId = response?.data?.data?.updatedCoupon?._id;
                await handleEditSubmit(couponId);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 404 || error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    // Close Edit Modal and set coupon data as empty.
    const handleCloseEditModal = () => {
        setOpenEditModal(false);
        setCouponData({
            isBogoCoupon: false,
            isSizeUpgradeCoupon: false,
            sizeUpgradeAddon: "",
            title: "",
            description: "",
            usageType: "",
            couponCode: "",
            discountPercent: "",
            discountAmount: "",
            validityStartDate: "",
            validityEndDate: "",
            discountPrice: "",
            applicableQuantityType: "",
            applicableProducts: [],
            excludedAddons: [] // Reset excludedAddons
        });
        setFile(null);
        setFromDate(null);
        setToDate(null);
        setSelectedCategories([]);
        setSelectedProducts([]);
        setSelectedUsers([]);
        setSelectedAddonGroups([]);
        setSelectedAddonValues([]);
        setFilteredAddonValues([]);
    }

    // Handles the submission of user-coupon allocation after successfully updating the coupon data.
    const handleEditSubmit = async (couponId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const selectedUsersData = selectedUsers.map((c) => c.value);
            const data = {
                _id: userCouponId,
                users: selectedUsersData,
                coupon_id: couponId
            }

            const response = await axios.put("user-coupon-allocation", data, {
                headers,
            });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                handleCloseEditModal()
                fetchData()
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if ( error.response?.status === 412 || error?.response?.status === 404 ) {
                    errorMessage = error?.response?.data?.data?.title;
                } else if (error.response?.status === 500 || error?.response?.status === 400) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    }

    console.log("ExProductList :", exProductList);
    

    useEffect(() => {
        if (updatingData && isVisible) {
            console.log('Updating Data:', updatingData?.users);
            assignExistingData(updatingData);
        }
    }, [updatingData, isVisible, allAddonList]); // Added allAddonList to dependency array

    return (
        <Modal
            size="xl"
            centered
            show={isVisible}
            onHide={handleCloseEditModal}
            aria-labelledby="VerticallyCenteredExample"
        >
            <Modal.Header closeButton>
                <Modal.Title>EDIT USER COUPON ALLOCATION DETAILS</Modal.Title>
            </Modal.Header>
            <Form onSubmit={submitEditForm}>
                <Modal.Body>
                    <Row className="mb-3">
                        <Col md={12} className='mb-3'>
                            <FormLabel className="fw-semibold">
                                Select Users <span className="text-danger">*</span>
                            </FormLabel>
                            <Select
                                isMulti
                                components={animatedComponents}
                                options={usersInfo}
                                value={selectedUsers || []}
                                onChange={handleSelectUsersChange}
                                onInputChange={(query) => {
                                    debouncedGetUsersList(query); // Fetch user list based on input query
                                }}
                                placeholder="Select Users"
                                closeMenuOnSelect={false}
                                styles={{
                                    ...customStyles,
                                    control: (base) => ({
                                        ...base,
                                        // minHeight: '100px', // Set the height
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                    }),
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#e9ecef",
                                        primary: "#007bff",
                                    },
                                })}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <FormCheck
                                type="checkbox"
                                id="isBogoCoupon"
                                label="Is BOGO Coupon ?"
                                checked={updatingData?.coupon_id?.isBogoCoupon}
                                disabled={updatingData?.coupon_id?.isComboCategoryCoupon || updatingData?.coupon_id?.sizeUpgradeAddon !== null}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <FormCheck
                                disabled={updatingData?.coupon_id?.isBogoCoupon || updatingData?.coupon_id?.isComboCategoryCoupon}
                                type="checkbox"
                                id="isSizeUpgradeCoupon"
                                label="Is Size Upgrade Coupon ?"
                                checked={updatingData?.coupon_id?.newSizeUpgradeAddon
                                    || updatingData?.coupon_id?.newSizeUpgradeAddon
                                    !== null}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <FormCheck
                                disabled={updatingData?.coupon_id?.isBogoCoupon || updatingData?.coupon_id?.sizeUpgradeAddon !== null}
                                checked={updatingData?.coupon_id?.isComboCategoryCoupon}
                                type="checkbox"
                                id="isComboCategoryCoupon"
                                label="Is Combo Category Coupon ?"
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <FormCheck
                                disabled={updatingData?.coupon_id?.isBogoCoupon || updatingData?.coupon_id?.sizeUpgradeAddon !== null || updatingData?.coupon_id?.isComboCategoryCoupon}
                                checked={updatingData?.coupon_id?.isMrpDiscount}
                                type="checkbox"
                                id="isComboCategoryCoupon"
                                label="Is MRP Coupon ?"
                            />
                        </Col>

                        {/* TITLE  */}
                        <Col md={3}>
                            <div>
                                <FormLabel className="fw-semibold">
                                    Title <span className="text-danger">*</span>
                                </FormLabel>
                                <FormControl
                                    placeholder="Title"
                                    name="title"
                                    value={editCouponData.title || ""}
                                    onChange={handleEditInputChange}
                                />
                            </div>
                        </Col>

                        {/* COUPON CODE  */}
                        <Col md={3}>
                            <div>
                                <FormLabel className="fw-semibold">
                                    Coupon Code <span className="text-danger">*</span>
                                </FormLabel>
                                <FormControl
                                    placeholder="Coupon Code"
                                    name="couponCode"
                                    value={editCouponData.couponCode || ""}
                                    onChange={handleEditInputChange}
                                />
                            </div>
                        </Col>

                        {/* VALIDITY START DATE */}
                        <Col className='mb-3' md={3}>
                            <div>
                                <FormLabel className="fw-semibold">
                                    Validity Start Date
                                </FormLabel>
                                <DatePicker
                                    onChange={handleEditValidStartDateChange}
                                    placeholderText="Start Date"
                                    className="form-control"
                                    selected={editCouponData?.validityStartDate ? new Date(editCouponData?.validityStartDate) : null}
                                />
                            </div>
                        </Col>

                        {/* VALIDITY END DATE */}
                        <Col md={3}>
                            <div>
                                <FormLabel className="fw-semibold">
                                    Validity End Date
                                </FormLabel>
                                <DatePicker
                                    selected={editCouponData?.validityEndDate ? new Date(editCouponData?.validityEndDate) : null}
                                    onChange={handleEditValidEndDateChange}
                                    placeholderText="End Date"
                                    className="form-control"
                                />
                            </div>
                        </Col>

                        {/* USAGE TYPE  */}
                        <Col md={3}>
                            <div>
                                <FormLabel className="fw-semibold">
                                    Usage Type <span className="text-danger">*</span>
                                </FormLabel>
                                <FormSelect
                                    name="usageType"
                                    value={editCouponData.usageType || "ONE-TIME"}
                                    onChange={handleEditInputChange}
                                >
                                    <option value="">Select Usage</option>
                                    <option value="MULTIPLE">MULTIPLE</option>
                                    <option value="ONE-TIME">ONE-TIME</option>
                                </FormSelect>
                            </div>
                        </Col>

                        {/* SELECT DAY OF THE WEEK  */}
                        <Col md={3}>
                            <div className="mb-3">
                                <FormLabel className="fw-semibold">
                                    Select Day of a week
                                </FormLabel>
                                <FormSelect
                                    size="sm"
                                    onChange={handleEditInputChange}
                                    name="dayOfWeek"
                                    className="mb-3"
                                    aria-label="Small select example"
                                    value={editCouponData?.dayOfWeek === null ? "all" : editCouponData?.dayOfWeek}
                                >
                                    <option value="">Select Day</option>
                                    <option value="0">SUNDAY</option>
                                    <option value="1">MONDAY</option>
                                    <option value="2">TUESDAY</option>
                                    <option value="3">WEDNESDAY</option>
                                    <option value="4">THURSDAY</option>
                                    <option value="5">FRIDAY</option>
                                    <option value="6">SATURDAY</option>
                                    <option value="all">ANY DAY OF THE WEEK</option>
                                </FormSelect>
                            </div>
                        </Col>

                        {/* START TIME */}
                        <Col md="3" lg="3">
                            <div className="mb-3">
                                <FormLabel className="fw-semibold">
                                    Start Time
                                </FormLabel>
                                <FormControl
                                    type="time"
                                    placeholder="Opening Time"
                                    className="form-control"
                                    name="startTime"
                                    value={editCouponData.startTime}
                                    onChange={handleEditInputChange}
                                />
                            </div>
                        </Col>

                        {/* END TIME  */}
                        <Col md="3" lg="3">
                            <div className="mb-3">
                                <FormLabel className="fw-semibold">
                                    End Time
                                </FormLabel>
                                <FormControl
                                    type="time"
                                    placeholder="Closing Time"
                                    className="form-control"
                                    name="endTime"
                                    value={editCouponData.endTime}
                                    onChange={handleEditInputChange}
                                />
                            </div>
                        </Col>

                        {/* SELECT INCLUDED OUTLETS  */}
                        <MultiSelectComponent
                            label="Select Included Outlets"
                            placeholder="Select Included Outlets"
                            options={editOutletData}
                            value={editSelections?.selectedIncludedOutlets || []}
                            onChange={(value) => handleChange("selectedIncludedOutlets", value)}
                            isDisabled={!!editSelections?.selectedExcludedOutlets?.length}
                        />

                        {/* SELECT EXCLUDED OUTLETS */}
                        <MultiSelectComponent
                            label="Select Excluded Outlets"
                            placeholder="Select Excluded Outlets"
                            options={outletData.filter(
                                (outlet) =>
                                    !editSelections.selectedIncludedOutlets?.some(
                                        (includedOutlet) => includedOutlet.value === outlet.value
                                    )
                            )}
                            value={editSelections.selectedExcludedOutlets || []}
                            onChange={(value) => handleChange("selectedExcludedOutlets", value)}
                            isDisabled={!!editSelections?.selectedIncludedOutlets?.length}
                        />

                        {/* SELECT APPLICABLE LEVELS  */}
                        <MultiSelectComponent
                            label="Select Applicable Levels"
                            placeholder="Select Applicable Levels"
                            value={editSelections?.selectedApplicableLevels || []}
                            onChange={(value) => handleChange("selectedApplicableLevels", value)}
                            options={levelsData}
                        />

                        {/* SELECT APPLICABLE PRODUCTS */}
                        {
                            <MultiSelectComponent
                                label=" Select Applicable Products"
                                placeholder=" Select Applicable Products"
                                value={editSelections.selectedApplicableProducts || []}
                                onChange={(value) => handleChange("selectedApplicableProducts", value)}
                                options={productsInfo}
                                isDisabled={!!editSelections.selectedApplicableCategories?.length || editCouponData.isBogoCoupon || editCouponData?.isComboCategoryCoupon}
                            />
                        }

                        {/* SELECT APPLICABLE CATEGORIES */}
                        <MultiSelectComponent
                            label="Select Applicable Categories"
                            placeholder="Select Applicable Categories"
                            value={editSelections.selectedApplicableCategories || []}
                            onChange={(value) => handleChange("selectedApplicableCategories", value)}
                            options={categoriesData}
                            isDisabled={!!editSelections.selectedApplicableProducts?.length || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isComboCategoryCoupon}
                        />

                        {/*  SELECT DEPENDENT CATEGORIES */}
                        <MultiSelectComponent
                            label="Select Dependent Categories"
                            placeholder="Select Dependent Categories"
                            value={editSelections.selectedDependentCategories || []}
                            onChange={(value) => handleChange("selectedDependentCategories", value)}
                            options={categoriesData}
                            isDisabled={editCouponData.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isComboCategoryCoupon}
                        />

                        {/* SELECT DEPENDENT PRODUCTS  */}
                        <MultiSelectComponent
                            label="Select Dependent Products"
                            placeholder="Select Dependent Products"
                            value={editSelections?.selectedDependentProducts || []}
                            onChange={(value) => handleChange("selectedDependentProducts", value)}
                            options={productsInfo}
                            isDisabled={editCouponData.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isComboCategoryCoupon}
                        />

                        {/* SELECT EXCLUDED PRODUCTS  */}
                        <MultiSelectComponent
                            label="Select Excluded Products"
                            placeholder="Select Excluded Products"
                            value={editSelections?.selectedExcludedProducts}
                            onChange={(value) => handleChange("selectedExcludedProducts", value)}
                            options={exProductsInfo}
                        />

                        {/* SELECT EXCLUDING ADDON GROUPS */}
                        <Col md={6} className='mb-3'>
                            <FormLabel className="fw-semibold">
                                Select Excluding Addon Groups
                            </FormLabel>
                            <Select
                                components={animatedComponents}
                                isMulti
                                options={allAddonList?.map(addon => ({
                                    value: addon._id,
                                    label: addon.title
                                })) || []}
                                value={selectedAddonGroups}
                                onChange={(options) => handleEditSelectAllAddonChange('excludedAddonGroups', options)}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select addon groups..."
                            />
                        </Col>
                        
                        {/* SELECT EXCLUDING ADDON VALUES */}
                        <Col md={6} className='mb-3'>
                            <FormLabel className='fw-semibold'>Select Excluding Addon Values</FormLabel>
                            <Select
                                components={animatedComponents}
                                isMulti
                                options={filteredAddonValues}
                                value={selectedAddonValues}
                                onChange={handleEditAddonValueChange}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select addon values to exclude..."
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => `${option.value.addonId}-${option.value.addValueId}`}
                                isDisabled={selectedAddonGroups.length === 0}
                            />
                        </Col>

                        {/* PRIMARY COMBO CATEGORIES */}
                        <MultiSelectComponent
                            label="Select Primary Combo Categories"
                            placeholder="Select Primary Combo Categories"
                            value={editSelections?.primaryComboCategories || []}
                            onChange={(value) => handleChange("primaryComboCategories", value)}
                            options={categoriesData.filter(
                                (category) =>
                                    !editSelections.secondaryComboCategories?.some(
                                        (cat) => cat.value === category.value
                                    )
                            )}
                            isDisabled={editCouponData.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isMrpDiscount}
                        />

                        {/* SECONDARY COMBO CATEGORIES  */}
                        <MultiSelectComponent
                            label="Select Secondary Combo Categories"
                            placeholder="Select Secondary Combo Categories"
                            value={editSelections.secondaryComboCategories || []}
                            onChange={(value) => handleChange("secondaryComboCategories", value)}
                            options={categoriesData.filter(
                                (category) =>
                                    !editSelections.primaryComboCategories?.some(
                                        (cat) => cat.value === category.value
                                    )
                            )}
                            isDisabled={editCouponData.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isMrpDiscount}
                        />

                        {/*SELECT SIZE UPGRADE ADDON */}
                        <Col md="3">
                            <FormLabel className="fw-semibold">
                                Select Size Upgrade Addon <span className="text-danger">*</span>
                            </FormLabel>
                            <FormSelect
                                name="newSizeUpgradeAddon"
                                value={editCouponData.newSizeUpgradeAddon}
                                onChange={(e) =>
                                    setEditCouponData((prev) => ({
                                        ...prev,
                                        newSizeUpgradeAddon: e.target.value,
                                    }))
                                }
                                disabled={editCouponData?.isComboCategoryCoupon || editCouponData?.isBogoCoupon || editCouponData?.isMrpDiscount}
                            >
                                <option value="">Select New Size Upgrade Addon</option>
                                {newSizeAddonsList?.map((add) => (
                                    <option value={add?._id} key={add?._id}>{add?.title} [{add.identifier}]</option>
                                ))}
                            </FormSelect>
                        </Col>

                        {/* COUPON STATUS */}
                        <Col md="3" className='mb-3'>
                            <FormLabel className="fw-semibold">
                                Coupon Status <span className="text-danger">*</span>
                            </FormLabel>
                            <FormSelect
                                name="status"
                                value={editCouponData.status}
                                onChange={handleEditInputChange}
                            >
                                <option value="">Select Status</option>
                                <option value="ACTIVE">ACTIVE</option>
                                <option value="INACTIVE">INACTIVE</option>
                            </FormSelect>
                        </Col>

                        {/* HIDE COUPON  */}
                        <Col md="3" className='mb-3'>
                            <FormLabel className="fw-semibold">
                                Hide Coupon <span className="text-danger">*</span>
                            </FormLabel>
                            <FormSelect
                                name="isHidden"
                                value={editCouponData.isHidden}
                                onChange={handleEditInputChange}
                            >
                                <option value="">Select Option</option>
                                <option value="true">YES</option>
                                <option value="false">NO</option>
                            </FormSelect>
                        </Col>

                        {/* ORDER TYPE  */}
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label className='fw-semibold'>
                                    Order Type <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="orderType"
                                    value={editCouponData.orderType || "ALL"}
                                    onChange={handleEditInputChange}
                                >
                                    <option value="ALL">ALL</option>
                                    <option value="DELIVERY">DELIVERY</option>
                                    <option value="PICKUP">PICK-UP</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        {/* IS MRP COUPON  */}
                        <Col md="3">
                            <FormLabel className="fw-semibold">
                                Is Mrp Coupon? <span className="text-danger">*</span>
                            </FormLabel>
                            <FormSelect
                                name="isMrpDiscount"
                                value={editCouponData.isMrpDiscount}
                                onChange={handleEditInputChange}
                                disabled={editCouponData?.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData?.isComboCategoryCoupon}
                            >
                                <option value="">Select Option</option>
                                <option value="true">YES</option>
                                <option value="false">NO</option>
                            </FormSelect>
                        </Col>

                        {/* DISCOUNT PERCENT  */}
                        <Col md={3} className={editCouponData?.isMrpDiscount ? "md-4" : "md-3"}>
                            <FormLabel className="fw-semibold">
                                Discount Percent <span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                min={0}
                                max={100}
                                disabled={
                                    editCouponData?.discountAmount || editCouponData?.discountPercent === undefined
                                }
                                placeholder="Discount Percent"
                                className="no-arrows"
                                type="number"
                                name="discountPercent"
                                value={editCouponData.discountPercent || ""}
                                onChange={handleEditInputChange}
                            />
                        </Col>

                        {/* Maximum Discount Amount */}
                        <Col md={3}>
                            <FormLabel className="fw-semibold">
                                Max. Dis. Amount
                            </FormLabel>
                            <FormControl
                                min={0}
                                disabled={editCouponData.isBogoCoupon || editCouponData.isSizeUpgradeCoupon || !!editCouponData.discountAmount || editCouponData.discountPrice}
                                placeholder="Max. Dis. Amount"
                                type="number"
                                className="no-arrows"
                                name="maxDiscountAmount"
                                value={editCouponData.maxDiscountAmount}
                                onChange={handleEditInputChange}
                            />
                        </Col>

                        {/* MINIMUM ORDER AMOUNT  */}
                        <Col className='mb-3' md={3} lg={3}>
                            <FormLabel className="fw-semibold">
                                Min. Order Amount
                            </FormLabel>
                            <FormControl
                                min={0}
                                placeholder="Min. Order Amount"
                                type="number"
                                className="no-arrows"
                                name="minOrderAmount"
                                value={editCouponData.minOrderAmount}
                                onChange={handleEditInputChange}
                            />
                        </Col>

                        {/* MAXIMUM ADDONS ALLOWED  */}
                        <Col md={3}>
                            <FormLabel className="fw-semibold">
                                Max Addons Allowed <span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                min={0}
                                placeholder="Max Addons Allowed"
                                className="no-arrows"
                                type="number"
                                name="maxAddonsAllowed"
                                value={
                                    editCouponData.maxAddonsAllowed === null || editCouponData.maxAddonsAllowed === undefined
                                        ? undefined
                                        : editCouponData.maxAddonsAllowed
                                }
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        handleEditInputChange(e);
                                    }
                                }}
                                // disabled={editCouponData?.isBogoCoupon || editCouponData?.isSizeUpgradeCoupon || editCouponData.isMrpDiscount}
                            />
                        </Col>

                        {/* DISCOUNT AMOUNT  */}
                        <Col md={3} className='mb-3'>
                            <FormLabel className="fw-semibold">
                                Discount Amount <span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                min={0}
                                step={0.01}
                                disabled={
                                    editCouponData?.discountPercent || editCouponData?.discountAmount === undefined
                                }
                                placeholder="Discount Amount"
                                className="no-arrows"
                                type="number"
                                name="discountAmount"
                                value={editCouponData.discountAmount || ""}
                                onChange={handleEditInputChange}
                            />
                        </Col>

                        {/* DISCOUNT PRICE  */}
                        <Col md={3}>
                            <FormLabel className="fw-semibold">
                                Discount Price <span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                min={0}
                                step={0.01}
                                disabled={
                                    editCouponData?.discountAmount || editCouponData?.discountPercent || editCouponData?.discountPrice === undefined
                                }
                                placeholder="Discount Price"
                                className="no-arrows"
                                type="number"
                                name="discountPrice"
                                value={editCouponData.discountPrice || ""}
                                onChange={handleEditInputChange}
                            />
                        </Col>

                        {/* APPLICABLE QUANTITY TYPE  */}
                        <Col md={3} className='mb-3'>
                            <div>
                                <FormLabel className="fw-semibold">
                                    Applicable Quantity Type <span className="text-danger">*</span>
                                </FormLabel>
                                <FormSelect
                                    name="applicableQuantityType"
                                    value={editCouponData.applicableQuantityType || ""}
                                    onChange={handleEditInputChange}
                                    disabled={
                                        editCouponData?.discountPercent || editCouponData?.discountAmount || editCouponData?.applicableQuantityType === undefined
                                    }
                                >
                                    <option value="">Select Applicable Quantity Type</option>
                                    <option value="SINGLE">SINGLE</option>
                                    {
                                        !editCouponData?.isComboCategoryCoupon && <option value="MULTIPLE">MULTIPLE</option>
                                    }
                                </FormSelect>
                            </div>
                        </Col>

                        {/* DESCRIPTION  */}
                        <Col md={12}>
                            <FormLabel className="fw-semibold">
                                Description <span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                as="textarea"
                                rows={2}
                                placeholder="Description"
                                name="description"
                                value={editCouponData.description || ""}
                                onChange={handleEditInputChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        {/* Other fields */}
                        <Col md="12" className="mb-3">
                            <div>
                                <FormLabel className="fw-semibold">
                                    Terms and Conditions <span className="text-danger">*</span>
                                </FormLabel>
                                <div className="d-flex mb-2">
                                    <FormControl
                                        placeholder="Add a term"
                                        value={currentTerm}
                                        onChange={(e) => setCurrentTerm(e.target.value)}
                                        className="me-2"
                                    />
                                    <Button disabled={!currentTerm.trim()} onClick={addEditTerm}>ADD</Button>
                                </div>
                                {editCouponData?.termsAndConditions?.length > 0 && (
                                    <ul className="list-group">
                                        {editCouponData?.termsAndConditions?.map((term, index) => (
                                            <li
                                                key={index}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                {term}
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger rounded-pill"
                                                    onClick={() => removeEditTerm(index)}
                                                >
                                                    Remove
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={isEditBtnLoading}
                        style={{ borderRadius: "18px" }}
                    >
                        {isEditBtnLoading ? 'Saving...' : 'SAVE CHANGES'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default EditModal